/**
 * Alert
 * Created by mayun50 on 2020/04/26.
 */
'use strict';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import LinearGradient from '@jdreact/jdreact-core-linear-gradient';

import {
    TouchableOpacity,
    View,
    TextInput
} from 'react-native';

import {
    JDTouchable,
    JDText,
    JDImage
} from '@jdreact/jdreact-core-lib';
import st from './style';
import { isIos } from '../../common/utils';
import { getImageUrl } from '../../common/newImg';

// import JDText from '../../common/text';

/**
 * Alert 弹框
 *
 * @param title （可选）  标题
 * @param modalShow （必填）  是否展示
 * @param overlayClickable（可选）  点击膜层后是否关闭对话框，默认是关闭的
 *
 */

export default class Alert extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            emailTxt: '',
            showClear: true
        };
        // this._onCancel = this._onCancel.bind(this);
        // this._onConfirm = this._onConfirm.bind(this);
    }

    render() {
        const {
            title,
            content,
            modalShow,
            overlayClickable,
            confirmText,
            cancelText,
            pwdError,
            pwdEmpty
        } = this.props;
        const { emailTxt, showClear } = this.state;

        return (
            modalShow && <View style={ st.container }>
                <View style={ st.modalContainer }>
                    {/* 遮罩层 */}
                    {
                        overlayClickable
                            ? <JDTouchable style={ st.mask } onPress={ this._onCancel } />
                            : <View style={ st.mask } />
                    }

                    {/* 弹框 */}
                    <View style={ st.innerContainer }>
                        <View style={ st.dialogInner }>
                            <View style={ st.content }>
                                {/* 标题 */}
                                {
                                    !!title &&
                                    <JDText style={ [st.content_color, st.title] }>{title}</JDText>
                                }
                                {content !== '' && <JDText style={ [st.content_color, st.main, st.content_view] }>{content}</JDText>}
                            </View>
                            <View style={ st.bottom_bx }>
                                {/* <JDText style={[st.text2, st.row1]}>邮箱</JDText> */}
                                <TextInput
                                    secureTextEntry={ true }
                                    style={ st.tel_input }
                                    placeholder='请输入密码'
                                    underlineColorAndroid='transparent'
                                    maxLength={ 20 }
                                    placeholderTextColor='#bbb'
                                    value={ emailTxt }
                                    keyboardType={ isIos ? 'numbers-and-punctuation' : 'numeric' }
                                    onChangeText={ this.email }
                                    onFocus={ () => { this.setState({ showClear: true }); } }
                                    onBlur={ () => { this.setState({ showClear: false }); } }
                                    iosreturnKeyType='done'
                                    returnKeyLabel='确认'
                                />

                                {showClear && emailTxt.length > 0
                                    ? <JDTouchable style={ st.clear_input } onPress={ this.clearTip }>
                                        <JDImage source={ { uri: getImageUrl('delemail') } } style={ st.clear_input_img } />
                                    </JDTouchable>
                                    : null}
                            </View>

                            {(pwdError || pwdEmpty) && <View style={ st.red_tip }>
                                <JDText style={ st.red_txt }>{pwdEmpty ? '请输入密码' : '密码输入错误，请重新输入'}</JDText>
                            </View>}

                            {/* <View style={st.actionGroup}>
                                {
                                    this.props.isShowCancel &&
                                    <TouchableOpacity activeOpacity={0.5} style={st.flex} onPress={this._onCancel}>
                                        <View style={[st.btn, st.cancelBtn]}>
                                            <JDText style={st.cancelText}>{cancelText}</JDText>
                                        </View>
                                    </TouchableOpacity>
                                }
                                <TouchableOpacity activeOpacity={0.5} style={st.flex} onPress={this._onConfirm}>
                                    <View style={st.btn}>
                                        <LinearGradient style={[st.view_btn, { borderWidth: 0 }]} colors={['#F10000', '#FF2000', '#FF4F18']} start={{ x: 0, y: 0 }} end={{ x: 1, y: 0 }} >
                                            <JDText style={st.text_white}>{confirmText}</JDText>
                                        </LinearGradient>
                                    </View>
                                </TouchableOpacity>
                            </View> */}
                            {
                                this.props.isShowCancel &&
                                <View style={ st.actionGroup }>

                                    <TouchableOpacity activeOpacity={ 0.5 } style={ st.flex } onPress={ this._onCancel }>
                                        <View style={ st.btn }>
                                            <View style={ st.view_btnds_left }>
                                                <JDText style={ st.text_red }>{cancelText}</JDText>
                                            </View>
                                        </View>
                                    </TouchableOpacity>

                                    <TouchableOpacity activeOpacity={ 0.5 } style={ st.flex } onPress={ this._onConfirm }>
                                        <View style={ st.btn }>
                                            <LinearGradient style={ [st.view_btnds, { borderWidth: 0 }] } colors={ ['#F10000', '#FF2000', '#FF4F18'] } start={ { x: 0, y: 0 } } end={ { x: 1, y: 0 } } >
                                                <JDText style={ st.text_white }>{confirmText}</JDText>
                                            </LinearGradient>
                                        </View>
                                    </TouchableOpacity>
                                </View>}
                            {
                                !this.props.isShowCancel &&
                                <View style={ st.actionGroup }>
                                    <TouchableOpacity activeOpacity={ 0.5 } style={ st.flex } onPress={ this._onConfirm }>
                                        <View style={ st.btn }>
                                            <LinearGradient style={ [st.view_btn, { borderWidth: 0 }] } colors={ ['#F10000', '#FF2000', '#FF4F18'] } start={ { x: 0, y: 0 } } end={ { x: 1, y: 0 } } >
                                                <JDText style={ st.text_white }>{confirmText}</JDText>
                                            </LinearGradient>
                                        </View>
                                    </TouchableOpacity>
                                </View>
                            }
                        </View>
                    </View>
                </View>
            </View>
        );
    }

    // 其他方法...
    _onCancel = () => {
        if (this.props.onCancel) {
            this.props.onCancel();

            return;
        }
        this.props.onClose && this.props.onClose();
    }

    _onConfirm = () => {
        this.props.onConfirm && this.props.onConfirm();
    }

    email = (emailTxt) => {
        this.setState({ emailTxt });
        this.props.getPwd(emailTxt);
    }

    clearTip = () => {
        this.setState({ emailTxt: '' });
    }
}
Alert.propTypes = {
    title: PropTypes.string,
    modalShow: PropTypes.bool,
    onConfirm: PropTypes.func, // 点击确定的回调方法
    onCancel: PropTypes.func, // 点击取消按钮的回调
    isShowCancel: PropTypes.bool, // 是否显示取消按钮
    cancelText: PropTypes.string, // 取消按钮文案
    confirmText: PropTypes.string // 确定按钮文案
};
Alert.defaultProps = {
    cancelText: '取消',
    confirmText: '确定'
};
